import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import s from "./UserDetails.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  Button,
  Checkbox,
  Col,
  Form,
  notification,
  Row,
  Select,
  Table,
} from "antd";
import { ColumnsType } from "antd/es/table";
import { getRole } from "../../data";
import moment from "moment";
import { useForm } from "antd/es/form/Form";
import { IUpdateUserParams, IUserListResponseResults } from "../../types";
import {
  getAdminUsersList,
  getManagerEmployeeDetails,
  getManagerEmployeesList,
  getUserDetails,
  getUsersList,
  updateUserByManager,
} from "../../redux/UserSlice";
import {
  ArrowLeftOutlined,
  CheckCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import { useTranslation } from "react-i18next";

interface TableType {
  entity_type?: string;
  phone?: string;
  company?: string;
  company_id?: string;
  country?: string;
  city?: string;
  eori?: string;
  date_joined?: string;
}

const UserDetails = () => {
  const [form] = useForm();
  const userDetails = useSelector((state: RootState) => state.user.userDetails);
  const employee = useSelector(
    (state: RootState) => state.user.managerEmployeeDetails
  );
  const role = useSelector((state: RootState) => state.auth.role);
  const [user, setUser] = useState(
    role === "regional_manager" ? employee : userDetails
  );
  const [isActive, setIsActive] = useState(user?.is_active);
  const [isEmailVerified, setIsEmailVerified] = useState(user?.email_verified);
  const dispatch: AppDispatch = useDispatch();
  const [changedValues, setChangedValues] =
    useState<IUserListResponseResults>();
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const roles = getRole(t);
  const me = useSelector((state: RootState) => state.auth.role);

  console.log("me", me);

  const currentPage = useSelector(
    (state: RootState) => state.user.usersListCurrentPage
  );

  const columns: ColumnsType<TableType | undefined> = [
    {
      title: t("Форма регистрации"),
      dataIndex: `entity_type`,
      width: 50,
    },
    {
      title: t("Телефон"),
      dataIndex: `phone`,
      width: 50,
    },
    {
      title: t("Компания"),
      dataIndex: `company`,
      width: 80,
    },

    {
      title: t("Страна"),
      dataIndex: `country`,
      width: 50,
    },
    {
      title: t("Город"),
      dataIndex: `city`,
      width: 50,
      align: "center",
    },

    {
      title: t("Зарегистрирован"),
      dataIndex: `date_joined`,
      width: 50,
      align: "center",
    },
  ];

  const columns2: ColumnsType<TableType | undefined> = [
    {
      title: t("Форма регистрации"),
      dataIndex: `entity_type`,
      width: 80,
    },
    {
      title: t("Телефон"),
      dataIndex: `phone`,
      width: 80,
    },

    {
      title: t("Страна"),
      dataIndex: `country`,
      width: 80,
    },
    {
      title: t("Город"),
      dataIndex: `city`,
      width: 50,
      align: "center",
    },

    {
      title: t("Зарегистрирован"),
      dataIndex: `date_joined`,
      width: 50,
      align: "center",
    },
  ];

  const columns3: ColumnsType<TableType | undefined> = [
    {
      title: t("Форма регистрации"),
      dataIndex: `entity_type`,
      width: 80,
    },

    {
      title: t("Страна"),
      dataIndex: `country`,
      width: 80,
    },
    {
      title: t("Город"),
      dataIndex: `city`,
      width: 50,
      align: "center",
    },

    {
      title: t("Зарегистрирован"),
      dataIndex: `date_joined`,
      width: 50,
      align: "center",
    },
  ];

  const columns4: ColumnsType<TableType | undefined> = [
    {
      title: t("Компания"),
      dataIndex: `company`,
      width: 80,
    },

    {
      title: t("Страна"),
      dataIndex: `country`,
      width: 50,
    },
    {
      title: t("Город"),
      dataIndex: `city`,
      width: 50,
      align: "center",
    },
  ];

  const openNotification =
    (pauseOnHover: boolean, title: string, type: "success" | "error") => () => {
      let icon;
      switch (type) {
        case "success":
          icon = <CheckCircleOutlined style={{ color: "green" }} />;
          break;

        case "error":
          icon = <WarningOutlined style={{ color: "red" }} />;
          break;
      }
      api.open({
        message: title,
        icon,
        showProgress: true,
        pauseOnHover,
      });
    };

  useEffect(() => {
    if (userDetails) {
      setUser(userDetails);
      form.setFieldsValue({
        role: userDetails?.role,
        is_active: userDetails?.is_active,
        email_verified: userDetails.email_verified,
      });
    }

    if (employee) {
      setUser(employee);
      form.setFieldsValue({
        is_active: employee?.is_active,
        email_verified: employee.email_verified,
        role: employee.role,
      });
    }
  }, [dispatch, userDetails, employee, form]);

  const onValuesChange = (
    changed: Partial<IUpdateUserParams>,
    allValues: IUpdateUserParams
  ) => {
    Object.keys(changed).find((key) => {
      setChangedValues((prev: any) => ({ ...prev, ...changed }));
      return true;
    });
  };

  const updateUser = async () => {
    if (user && user.id && changedValues) {
      if (me === "admin") {
        const res = await dispatch(
          updateUserByManager({
            id: user.id,
            params: changedValues,
          })
        );
        if (res.type === "user/updateUserByManager/fulfilled") {
          dispatch(getUserDetails(user.id));
          dispatch(getUsersList(1));
          openNotification(
            true,
            t("Вы обновили информацию о пользователе!"),
            "success"
          )();

          setTimeout(() => {
            navigate("/users");
          }, 2000);
        }
      }

      if (me === "regional_manager") {
        const res = await dispatch(
          updateUserByManager({
            id: user.id,
            params: changedValues,
          })
        );

        if (res.type === "user/updateUserByManager/fulfilled") {
          dispatch(getManagerEmployeeDetails(user.id));
          dispatch(getManagerEmployeesList(1));
          openNotification(
            true,
            t("Вы обновили информацию о пользователе!"),
            "success"
          )();
          setTimeout(() => {
            navigate("/employees");
          }, 2000);
        }
      }
    }
  };

  return (
    <div>
      {contextHolder}
      {width > 985 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <Link
          to={role === "regional_manager" ? "/employees" : "/users"}
          className={s.back}
          onClick={
            role === "regional_manager"
              ? () => dispatch(getManagerEmployeesList(currentPage))
              : () => dispatch(getAdminUsersList(currentPage))
          }
        >
          <ArrowLeftOutlined className={s.backIcon} />
          &nbsp;{t("Назад")}
        </Link>
        <h2 className={s.h2}>{user?.full_name}</h2>
        <div className={s.email}>{user?.email}</div>
        {width < 750 ? <div className={s.phone}>{user?.phone}</div> : null}
        <Table
          pagination={false}
          columns={
            width > 750
              ? user?.entity_type === "individual"
                ? columns2
                : columns
              : user?.entity_type === "individual"
                ? columns3
                : columns4
          }
          dataSource={[
            {
              entity_type:
                user?.entity_type === "individual" ? "Физ.лицо" : "Юр.лицо",
              phone: user?.phone,
              company: user?.company_name,
              company_id: user?.company_id,
              country: user?.registered_country,
              city: user?.city,
              eori: user?.eori,
              date_joined: moment(user?.date_joined).format("DD.MM.YYYY"),
            },
          ]}
        />
        <div className={s.edit}>
          {/* <div className={s.h2}>Редактировать</div> */}
          <Form
            layout="vertical"
            form={form}
            onFinish={updateUser}
            onValuesChange={onValuesChange}
          >
            <Row gutter={24}>
              {user?.role === "admin" && (
                <Col span={width > 750 ? 6 : 24}>
                  <Form.Item name="role" label={t("Роль")}>
                    <Select
                      className={s.select}
                      placeholder={t("Выберите роль")}
                      options={roles.map((it) => ({
                        label: it.label,
                        value: it.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col span={width > 750 ? 3 : 8}>
                <Form.Item
                  name="is_active"
                  label={t("Активный")}
                  valuePropName="checked"
                >
                  <Checkbox
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 750 ? 6 : 16}>
                <Form.Item
                  label={t("Email Верифицирован")}
                  name="email_verified"
                  valuePropName="checked"
                >
                  <Checkbox
                    checked={isEmailVerified}
                    onChange={(e) => setIsEmailVerified(e.target.checked)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Button className={s.btn} htmlType="submit">
                {t("Подтвердить")}
              </Button>
            </Row>
          </Form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UserDetails;
